// extracted by mini-css-extract-plugin
export default {"spinner":"DotsSpinner_spinner__mbDLD","dot":"DotsSpinner_dot__Qx89A","loading":"DotsSpinner_loading__OaLxR"};